import { IResponseHttp } from '@core/models';

export function unwrapResponse<T>(response: IResponseHttp | T): T {
  if (
    response &&
    typeof response === 'object' &&
    'status' in response &&
    'msg' in response
  ) {
    return ((response as IResponseHttp).payload as T) ?? ({} as T);
  }
  return response as T;
}

export function toObject(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : {};
}

export function readString(value: unknown, key: string): string {
  if (!value || typeof value !== 'object') return '';
  const result = (value as Record<string, unknown>)[key];
  return typeof result === 'string' ? result : '';
}

export function readStringByKeys(value: unknown, keys: string[]): string {
  if (!value || typeof value !== 'object') return '';
  const source = value as Record<string, unknown>;
  for (const key of keys) {
    const result = source[key];
    if (typeof result === 'string') return result;
  }
  return '';
}

export function readNullableString(value: unknown, key: string): string | null {
  if (!value || typeof value !== 'object') return null;
  const result = (value as Record<string, unknown>)[key];
  return typeof result === 'string' ? result : null;
}

export function readNullableStringByKeys(value: unknown, keys: string[]): string | null {
  if (!value || typeof value !== 'object') return null;
  const source = value as Record<string, unknown>;
  for (const key of keys) {
    const result = source[key];
    if (typeof result === 'string') return result;
  }
  return null;
}

export function readNumber(value: unknown, key: string): number {
  if (!value || typeof value !== 'object') return 0;
  const result = (value as Record<string, unknown>)[key];
  return typeof result === 'number' && Number.isFinite(result) ? result : 0;
}

export function readNullableBoolean(value: unknown, key: string): boolean | null {
  if (!value || typeof value !== 'object') return null;
  const result = (value as Record<string, unknown>)[key];
  return typeof result === 'boolean' ? result : null;
}

export function getFileExtension(fileName: string, mimeType: string): string {
  const fromName = fileName.split('.').pop()?.trim().toLowerCase();
  if (fromName) {
    return fromName;
  }
  if (mimeType.includes('pdf')) {
    return 'pdf';
  }
  if (mimeType.includes('png')) {
    return 'png';
  }
  return 'jpg';
}
